namespace $.$$ {

	export class $shm_hitalama_map_widget_float_form_string extends $.$shm_hitalama_map_widget_float_form_string {

		@ $mol_mem
		input_event( next?: Event ) { return next ?? null }

		input_snapshot( event: Event ) {
			const el = this.dom_node() as HTMLInputElement
			this.input_event( event )
			return { value: el.value, from: el.selectionStart, to: el.selectionEnd }
		}

		@ $mol_action
		override event_change( event?: Event ) {
			if( !event ) return
			// A resumed event must not reread a later DOM value/caret or restore
			// an older selection over a newer input event.
			const snapshot = this.$.$mol_wire_sync( this ).input_snapshot( event )
			const value = this.value_changed( snapshot.value )
			if( this.input_event() !== event ) return
			const el = this.dom_node() as HTMLInputElement
			el.value = value
			if( snapshot.to === null ) return
			el.selectionEnd = snapshot.to
			el.selectionStart = snapshot.from
			$mol_string.prototype.selection_change.call( this, event )
		}

		@ $mol_mem
		override value_changed( next?: string ): string {
			const el = this.dom_node() as HTMLInputElement
			el.setCustomValidity( '' )
			// Base $mol_string catches suspended setters and treats their input as
			// saved. Keep Promise propagation so event_change resumes the write.
			return this.$.$mol_error_fence(
				()=> this.value( next ),
				error => {
					this.$.$mol_fail_log( error )
					if( error instanceof Error ) {
						el.setCustomValidity( error.message )
						el.reportValidity()
					}
					return next ?? this.$.$mol_mem_cached( ()=> this.value_changed() ) ?? ''
				},
			)
		}

	}

}
